import React, { useContext, useEffect, useState } from 'react';
import { AdminContext } from '../../context/AdminContext';
import ToolbarIcons from '../../icons/toolbar';
import AppInput from '../AppInput';
import Loader from '../Loader';
import styles from './style.module.css';

const AppSearch = ({
  searchValue = '',
  setSearchValue,
  autoFocus = false,
  onFocus,
  inputClassName = '',
  onCloseFunction,
}) => {
  const [searchInput, setSearchInput] = useState('');
  const { themeColor, content } = useContext(AdminContext);

  useEffect(() => {
    setSearchInput(searchValue);
  }, [searchValue]);

  const changeInput = (e) => {
    setSearchValue(e.target.value);
  };

  const pressKey = (e) => {
    if (e.keyCode === 13) {
      setSearchValue(searchInput);
    }
  };
  console.log('search', searchInput, searchValue);
  return (
    <>
      <div className={`${styles.className} relative  `}>
        <AppInput
          autoFocus={autoFocus}
          affix={
            <span
              className={`flex flex-row justify-center item-center px-1 ${inputClassName}`}
              onClick={() => {
                setSearchInput('');
                setSearchValue('');
                onCloseFunction();
              }}
            >
              {searchInput?.length != 0 && (
                <ToolbarIcons.CloseIcon width={'13px'} height={'13px'} />
              )}
            </span>
          }
          onFocus={onFocus}
          affix2={
            <span className="flex flex-row justify-center item-center">
              <ToolbarIcons.SearchIcon
                width={'18px'}
                height={'18px'}
                onClick={() => {
                  setSearchValue(searchInput);
                }}
              />
            </span>
          }
          placeholder={content?.search}
          className={`message ${styles.input} p-0 ${
            themeColor == 'black' ? 'modalHeaderBg textWhite noBorder' : ''
          }`}
          onChange={(e) => {
            changeInput(e);
          }}
          value={searchInput}
          onKeyDown={(e) => {
            pressKey(e);
          }}
        />
      </div>
    </>
  );
};
export default AppSearch;
